/**
 * Admin shop moderation API helpers.
 */
import apiService from '../ApiService';
import type { Shop, ShopRequest } from '../../types/buildExpansion';

const ENDPOINT = '/admin/shop_moderation.php';

export interface AdminModerationShopRow extends Shop {
  creator_username: string | null;
  build_count: number;
  claim_status: string;
}

export interface ShopModerationLogEntry {
  id: number;
  shop_id: number | null;
  request_id: number | null;
  admin_user_id: number;
  action: string;
  details_json: string | null;
  created_at: string;
  admin_username: string | null;
}

export async function adminGetShopRequestQueue(status?: string): Promise<ShopRequest[]> {
  const qs = new URLSearchParams({ view: 'queue' });
  if (status) qs.set('status', status);
  const response = await apiService.makeRequest<{ requests?: ShopRequest[] }>(
    `${apiService.getAdminEndpoint(ENDPOINT)}?${qs}`,
    { headers: apiService.getAuthHeaders() }
  );
  return response.data?.requests ?? [];
}

export async function adminGetDirectoryShops(status?: string): Promise<AdminModerationShopRow[]> {
  const qs = new URLSearchParams({ view: 'shops' });
  if (status) qs.set('status', status);
  const response = await apiService.makeRequest<{ shops?: AdminModerationShopRow[] }>(
    `${apiService.getAdminEndpoint(ENDPOINT)}?${qs}`,
    { headers: apiService.getAuthHeaders() }
  );
  return response.data?.shops ?? [];
}

export async function adminShopModerationAction(payload: Record<string, unknown>): Promise<void> {
  const response = await apiService.makeRequest(apiService.getAdminEndpoint(ENDPOINT), {
    method: 'POST',
    body: JSON.stringify(payload),
    headers: apiService.getAuthHeaders(),
  });
  if (!response.success) {
    throw new Error(response.error || 'Moderation action failed');
  }
}

export async function adminGetShopModerationLog(
  shopId?: number,
  requestId?: number
): Promise<ShopModerationLogEntry[]> {
  const qs = new URLSearchParams({ view: 'log' });
  if (shopId) qs.set('shop_id', String(shopId));
  if (requestId) qs.set('request_id', String(requestId));
  const response = await apiService.makeRequest<{ log?: ShopModerationLogEntry[] }>(
    `${apiService.getAdminEndpoint(ENDPOINT)}?${qs}`,
    { headers: apiService.getAuthHeaders() }
  );
  return response.data?.log ?? [];
}
